import { Navigate } from 'react-router-dom';
import { Role } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';

/**
 * Redirige l'index `/primes` selon le rôle : un System (C-level) atterrit sur le
 * dashboard de synthèse, un Tam (Admin) sur la consultation mensuelle de ses primes.
 */
const PrimesIndexRedirect = () => {
  const auth = useAuthStore((state) => state.auth);
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;

  return <Navigate to={isSystem ? 'dashboard' : 'mois'} replace />;
};

export default PrimesIndexRedirect;
